import o from "./index133.js";
/* empty css         */
import t from "./index130.js";
const e = /* @__PURE__ */ t(o, [["__scopeId", "data-v-23dbe9ba"]]);
export {
  e as default
};
